import axios from '@/libs/api.request';

export const getMsgList = data => {
    return axios.request({
        url: 'web/systemManagement/msg/getPageMsgList',
        data: data,
        method: 'post'
    });
};

export const saveMsg = data => {
    return axios.request({
        url: 'api/systemManagement/msg/saveMsg',
        data: data,
        method: 'post'
    });
};
